module.exports = __webpack_public_path__ + "img/huangkaile.a72680d0.jpg";